import { map } from 'rxjs/operators';
import { Inject, Injectable, Pipe, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, throwError, timer } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { finalize, share, shareReplay, tap, retryWhen, take } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

import 'rxjs';
import { timeout } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
	providedIn: 'root',
})

export class CommonService {
	// public logo_image: string = '../../../public/img/logo.png' // environment.domainSecured + '/api/directory/image/1';

	// public logo: string = '../../../public/img/logo.png';
	// public logoBlank: string = '../../../public/img/logo.png';
	// public logoAvatar: string = '../../../public/img/logo.png';
	// public logoAvatarGrey: string = '../../../public/img/logo.png';
	// public noUser: string = '../../../public/img/no-user.jpg';
	
	items: any;
	item: any;
	onChanged: BehaviorSubject<any>;

	constructor(private httpClient: HttpClient,
		private cookieService: CookieService,
		private router: Router,@Inject(PLATFORM_ID) private platformId: Object) {
		this.onChanged = new BehaviorSubject([]);
	}
	
	header = new HttpHeaders({
		'Content-Type': 'application/json'
	});

	// Store New Item Data
	getItem(url: string, data: any): Observable<any> {
		if (data === null) { data = {}; }
		const body = JSON.stringify(data);
		return this.httpClient.post(url, body, { headers: this.header }).pipe(
			timeout(25000),
			map((response: any) => {
				return response;
			}),
			retry({ count: 2, delay: 1000 }),
			catchError(error => {
				throw error;
			})
		);
	}

	// Store New Item Data
	storeItem(url: string, data: any): Observable<any> {
		if (data === null) { data = {}; }
		const body = JSON.stringify(data);
		// localStorage.getItem("token")
		let header = new HttpHeaders().set("Authorization", 'sdkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk');
		header = new HttpHeaders().set('Content-Type', 'application/json');
		return this.httpClient.post(url, body, { headers: header }).pipe(
			timeout(25000),
			map((response: any) => {
				return response;
			}),
			retry({ count: 2, delay: 1000 }),
			catchError(error => {
				throw error;
			})
		);
	}


	handleError(error: any) {
		if (error === 'Unauthenticated' || error === 'Unauthenticated.' || error === 'Token invalid or missing') {
			// this.clearMemory();
		}
		// let errorMessage = '';
		// if (error.error instanceof ErrorEvent) {
		//     // client-side error
		//     errorMessage = `Error: ${error.error.message}`;
		// } else {
		//     // server-side error
		//     errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
		// }
		// console.log(errorMessage);
		// error = success
		return throwError(error);
	}

	// clearMemory() {

	// 	this.cookieService.deleteAll();
	// 	if (this.cookieService.check('tji_token')) {
	// 		this.cookieService.delete('tji_token', '/');
	// 	}
	// 	if (this.cookieService.check('tji_user')) {
	// 		this.cookieService.delete('tji_user', '/');
	// 	}
	// 	if (this.cookieService.check('tji_permissions')) {
	// 		this.cookieService.delete('tji_permissions', '/');
	// 	}
	// 	if (this.cookieService.check('tji_roles')) {
	// 		this.cookieService.delete('tji_roles', '/');
	// 	}
	// 	if (this.cookieService.check('language')) {
	// 		this.cookieService.delete('language', 'en');
	// 	}
	// 	localStorage.clear();
	// 	window.location.reload();
	// 	this.router.navigate(["/"]);
	// }

	setLanguage(lang: string = 'en') {
		if (isPlatformBrowser(this.platformId)) {
			this.cookieService.set('language', lang);
			localStorage.setItem('language', lang);
		}
	}

	getLanguage(): string {
		let lang: string = 'en';
		if (this.cookieService.check('language')) {
			lang = this.cookieService.get('language');
		}else {
			lang = 'en';
		}
		return lang;
	}

}

